import React, { Fragment } from 'react';
import dotProp from 'dot-prop-immutable';

import { withStyles } from '@mui/styles';

import Cell from '../Cell';
import Loader from '../Loader';
import ComponentWrapper from '../ComponentWrapper';
import FullScreenDialog from '../FullScreenDialog';
import CreateVirtualTrpl from './CreateVirtualTrpl';

import { Tab, Tabs, Table, Button, TableRow, TableBody } from '@mui/material';

import TrplSelect from '../TrplControls/TrplSelect';
import TrplCheckbox from '../TrplControls/TrplCheckbox';
import TrplTextfield from '../TrplControls/TrplTextfield';

import { getJsonValue } from '../../utils';

const styles = {
  tableCell: {
    padding: '10px',
  },
  pidTableCell: {
    width: '1px',
    paddingRight: '10px',
    paddingLeft: '24px',
  },
  typeTableCell: {
    width: '1px',
    paddingRight: '10px',
    paddingLeft: '0',
    textTransform: 'uppercase',
  },
  tableCellValue: {
    color: 'gray',
  },
  numberTextField: {
    width: '100px',
  },
  fullWidthTextField: {
    width: '100%',
  },
  currency: {
    marginLeft: '10px',
  },
  alignCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  saveBtn: { marginLeft: '30px' },
  deleteBtn: { marginLeft: '30px' },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '50px',
  },
  loadMoreFiltersContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '10px 0',
  },
};

class TrplRenderPartsModal extends ComponentWrapper {
  constructor() {
    super();

    this.state = {
      mode: '',
      data: {},
      tab: 'table',
      trplData: {},
      trplValue: '',
      trplValues: [],
      trplTableInputValues: {},
      trplTableFilterValues: [],
      modalData: {
        trpl: {},
        restriction: {},
        node: {},
      },
      loadMoreCounter: 10,
      loadMoreCounterStep: 10,
      isDataLoaded: false,
    };
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    return this.props.isOpen !== nextProps.isOpen || this.state !== nextState;
  };

  onEnter = () => {
    const { data, modalData } = this.props;
    const { node, rst, trpl } = modalData;

    this.setState(
      {
        data,
        modalData: {
          node: node,
          restriction: rst,
          trpl,
        },
        trplValues: rst ? rst.values : [],
        trplData: {
          trplSelectValues: {
            [rst ? rst.id : 'none']: trpl ? trpl.val : '',
          },
        },
        trplValue: trpl ? trpl.val : '',
      },
      () => {
        if (rst && rst.render_parts && trpl && trpl.tid) {
          this.prepareDataWithRenderParts();
        } else {
          this.setState({ isDataLoaded: true });
        }
      }
    );
  };

  onExit = () => {
    this.setState({
      mode: '',
      trplData: {},
      trplValue: '',
      trplValues: [],
      trplTableInputValues: {},
      trplTableFilterValues: [],
      modalData: {
        trpl: {},
        restriction: {},
        node: {},
      },
      loadMoreCounter: 10,
      loadMoreCounterStep: 10,
      isDataLoaded: false,
      data: {},
    });
  };

  getTrplData = (tid, cb) => {
    this.post({
      url: `/get_triple_data?tid=${tid}`,
      cb: (res) => {
        if (cb) cb(res);
      },
    });
  };

  updTrpl = (params, cb) => {//combine with editTrpl
    const { sid, pid, oid, inverted, value, func, data, render } = params;

    const dataInStr = {
      sid: sid || '',
      pid: pid || '',
      oid: oid || 0,
      inverted: inverted || false,
      val: value !== undefined ? value : '',
      func: func || '',
      data: data || '',
      render: render || '',
    };

    this.postWithData({
      url: `/rest/upd_trpl`,
      data: dataInStr,
      cb: (res) => {
        if (cb) cb(res);
      },
    });
  };

  editTrpl = () => {
    const { trpl } = this.state.modalData;

    const dataStringified = {
      tid: trpl.tid,
      val: trpl.value || '',
      func: trpl.func || '',
      data: JSON.stringify(trpl.data) || '{}',
      render: trpl.render || '',
    };

    this.postWithData({
      url: `/rest/upd_trpl`,
      data: dataStringified,
      cb: (res) => {
        console.log(res);
      },
    });
  };

  prepareDataWithRenderParts = () => {
    let { trplValue, trplTableFilterValues } = this.state;
    let { trpl, restriction } = this.state.modalData;

    const trplTableInputValues = {};

    this.getTrplData(trpl.tid, (trplData) => {
      trplData.trplSelectValues = {};

      if (trplData.render_parts) {
        trplData.render_parts.forEach((renderPart, renderPartIndex) => {
          trplData.trplSelectValues[renderPart] = trplData.structure_vars[renderPartIndex][0];

          trplTableFilterValues.push('');
        });

        trplValue = this.getTrplValue(trplData);

        trplData.structure_matrix.forEach((structure) => {
          structure.forEach((str) => {
            let value = getJsonValue(structure, trplData.trpl_data);

            trplTableInputValues[structure.toString()] = value;
          });
        });
      } else {
        if (trplData.restrictions[restriction.id].values.indexOf(trplData.val) !== -1) {
          trplData.trplSelectValues[restriction.id] = trplData.val;
        } else {
          trplData.trplSelectValues[restriction.id] = trplData.restrictions[restriction.id].values[0];
        }
      }

      this.setState({
        trplData,
        trplTableInputValues,
        trplTableFilterValues,
        trplValue,
        isDataLoaded: true,
      });
    });
  };

  getTrplValue = (trplData) => {
    const trplSelectValues = [];

    if (trplData.render_parts) {
      trplData.render_parts.forEach((renderPart) => {
        trplSelectValues.push(trplData.trplSelectValues[renderPart]);
      });
    } else {
      Object.keys(trplData.trplSelectValues).forEach((val) => trplSelectValues.push(trplData.trplSelectValues[val]));
    }

    return getJsonValue(trplSelectValues, trplData.trpl_data);
  };

  onTrplTableValueChange = (key, e) => {
    const { trplTableInputValues } = this.state;
    const { restriction } = this.state.modalData;

    if (restriction.type === 'BOOLEAN') {
      trplTableInputValues[key] = `${e.target.checked}`;
    } else {
      trplTableInputValues[key] = e.target.value;
    }

    this.setState({ trplTableInputValues });
  };

  onTrplTableFilterChange = (index, e) => {
    const { trplData, trplTableFilterValues, loadMoreCounter } = this.state;

    if (loadMoreCounter !== Object.keys(trplData.structure_matrix).length) {
      this.onLoadAllFiltersClick();
    }

    trplTableFilterValues[index] = e.target.value;

    this.setState({ trplData, trplTableFilterValues });
  };

  setValueToTrplData = (keys, value) => {
    let { trplData } = this.state;

    const updatedTrplData = dotProp.set(trplData.trpl_data, keys.join('.'), value);

    trplData.trpl_data = updatedTrplData;

    this.setState({ trplData });
  };

  saveValueFromTrplTable = (keys) => {
    const { modalData, trplTableInputValues } = this.state;
    let { trplData, trplValue } = this.state;

    const data = {
      tid: modalData.trpl.tid,
      value: trplTableInputValues[keys.toString()],
    };

    Object.keys(keys).forEach((key, index) => {
      if (typeof keys[key] !== 'boolean') {
        data[`key${index}`] = keys[key];
      }
    });

    if (trplData.render_parts) {
      let selectKeys = [];

      trplData.render_parts.forEach((renderPart) => {
        selectKeys.push(trplData.trplSelectValues[renderPart]);
      });

      this.setValueToTrplData(keys, data.value);

      if (keys.toString() === selectKeys.toString()) {
        trplValue = data.value;
        this.setState({ trplValue });
      }
    }

    this.postWithData({
      url: `/rest/settriplejsonval`,
      data,
      cb: () => {
        const { updateParentData } = this.props;

        if (updateParentData) updateParentData();
      },
    });
  };

  onTrplValueSelectChange = (e, rst) => {
    let { trplData, trplValue } = this.state;

    trplData.trplSelectValues[rst] = e.target.value;

    const selectValues = [];

    if (trplData.render_parts) {
      trplData.render_parts.forEach((renderPart) => {
        selectValues.push(trplData.trplSelectValues[renderPart]);
      });
    } else {
      Object.keys(trplData.trplSelectValues).forEach((val) => selectValues.push(trplData.trplSelectValues[val]));
    }

    this.setState({ trplData }, () => {
      trplValue = getJsonValue(selectValues, trplData.trpl_data);

      this.setState({ trplValue, selectValues });
    });
  };

  onTrplTextValueChange = (trplValue) => {
    this.setState({ trplValue });
  };

  onVirtualRestrictionTextChange = (value, key, mode) => {
    let { modalData, trplData } = this.state;

    if (mode === 'edit') {
      trplData[key] = value;
    } else {
      modalData.restriction[key] = value;
    }

    this.setState({ modalData });
  };

  onTrplValueSaveClick = () => {
    const data = {
      tid: this.state.modalData.trpl.tid,
      value: this.state.trplValue,
    };

    const { trplData, trplTableInputValues } = this.state;
    const { trplSelectValues } = this.state.trplData;

    let selectValues = [];

    if (trplData.render_parts) {
      trplData.render_parts.forEach((renderPart) => {
        selectValues.push(trplData.trplSelectValues[renderPart]);
      });

      const updatedTrplData = dotProp.set(trplData.trpl_data, selectValues.join('.'), data.value);

      let selectValuesStr = selectValues.join(',');
      trplTableInputValues[selectValuesStr] = `${data.value}`;

      trplData.trpl_data = updatedTrplData;

      this.setState({ trplTableInputValues, trplData });
    }

    const keysArray = selectValues && selectValues.length ? selectValues : Object.keys(trplSelectValues);

    keysArray.forEach((key, index) => {
      if (typeof trplSelectValues[key] !== 'boolean') {
        data[`key${index}`] = trplData.render_parts ? key : trplSelectValues[key];
      }
    });

    this.postWithData({
      url: `/rest/settriplejsonval`,
      data,
    });
  };

  onTrplValueCheckboxChange = (e) => {
    this.setState({ trplValue: `${e.target.checked}` });
  };

  removeTrpl = () => {
    const { tid } = this.state.modalData.trpl;

    this.get({
      url: `/rest/del_trpl?id=${tid}`,
    });
  };

  onCreateVirtualTrplBtn = () => {
    const { trpl, node, restriction } = this.state.modalData;

    if (trpl && trpl.tid) {
      this.editTrpl();
    } else {
      this.updTrpl(
        {
          sid: node.id,
          pid: restriction.id,
          oid: 0,
          inverted: restriction.inverted || false,
          func: restriction.func,
          data: JSON.stringify(restriction.data),
          render: restriction.render,
          value: restriction.value,
        },
        () => {
          const { updateDataOnCreateTrpl } = this.props;

          if (updateDataOnCreateTrpl) {
            updateDataOnCreateTrpl(() => {
              this.onEnter();
            });
          }
        }
      );
    }
  };

  onLoadMoreFiltersClick = () => {
    let { loadMoreCounter } = this.state;
    const { loadMoreCounterStep } = this.state;

    this.setState({
      loadMoreCounter: (loadMoreCounter += loadMoreCounterStep),
    });
  };

  onLoadAllFiltersClick = () => {
    const { trplData } = this.state;

    let loadMoreCounter = Object.keys(trplData.structure_matrix).length;

    this.setState({ loadMoreCounter });
  };

  onTabClick = (tab) => {
    this.setState({ tab });
  };

  render() {
    const { isOpen, onClose, locations } = this.props;

    const {
      tab,
      trplData,
      trplValue,
      isDataLoaded,
      loadMoreCounter,
      trplTableInputValues,
      trplTableFilterValues,
    } = this.state;

    const { restriction, trpl } = this.state.modalData;

    const { classes } = this.props;

    const isTextarea = restriction.type === 'TEXT' || restriction.type === 'DESCRIPTION';
    const isPrice = restriction.type === 'PRICE';

    const isBool = restriction.type === 'BOOLEAN';
    const isNumber = restriction.type === 'FLOAT' || restriction.type === 'INTEGER';

    const renderParts = trplData.render_parts;

    const locationIndex = renderParts ? renderParts.indexOf('LOCATION') : null;
    const textFieldClassName = isNumber ? classes.numberTextField : isTextarea ? classes.fullWidthTextField : '';

    const isNeedPrice = isPrice && locationIndex !== null;
    const currency = isNeedPrice
      ? locations[trplData.trplSelectValues['LOCATION']] && [trplData.trplSelectValues['LOCATION']].currency
      : '';

    return (
      <FullScreenDialog
        isOpen={isOpen}
        onClose={onClose}
        onEnter={this.onEnter}
        title={trpl && trpl.tid ? 'Edit triple' : 'Create virtual triple'}
      >
        {!isDataLoaded ? (
          <div className={classes.loaderContainer}>
            <Loader />
          </div>
        ) : !renderParts ? (
          <CreateVirtualTrpl
            restriction={restriction}
            onCreateVirtualTrplBtn={this.onCreateVirtualTrplBtn}
            onVirtualRestrictionTextChange={this.onVirtualRestrictionTextChange}
          />
        ) : (
          <div>
            <Tabs
              style={{
                background: '#f9f9f9',
              }}
              value={tab}
              variant="fullWidth"
              textColor="primary"
              indicatorColor="primary"
              onChange={(e, value) => this.onTabClick(value)}
            >
              <Tab style={{ maxWidth: 'none' }} value="table" label="Table" />
              <Tab style={{ maxWidth: 'none' }} value="simple" label="Simple" />
              <Tab style={{ maxWidth: 'none' }} value="advanced" label="Advanced" />
            </Tabs>

            {tab === 'simple' ? (
              <Table key="set-value" style={{ marginBottom: `${renderParts ? '50px' : '0'}` }}>
                <TableBody>
                  {renderParts ? (
                    <TableRow>
                      <Cell className={classes.pidTableCell}>{restriction.id}</Cell>
                      <Cell className={classes.typeTableCell}>{restriction.type}</Cell>

                      {renderParts.map((renderPart, renderPartIndex) => {
                        const restriction = trplData.restrictions[renderPart];

                        let restrictionTitle;
                        let restrictionValues;

                        if (!restriction) {
                          restrictionTitle = renderPart;
                          restrictionValues = trplData.structure_vars[renderPartIndex];
                        } else {
                          restrictionTitle = restriction.title;
                          restrictionValues = restriction.values;
                        }

                        return (
                          <Cell className={classes.tableCell} key={renderPartIndex}>
                            <TrplSelect
                              value={trplData.trplSelectValues[renderPart]}
                              title={restrictionTitle}
                              onChange={(e) => this.onTrplValueSelectChange(e, renderPart)}
                              values={restrictionValues}
                            />
                          </Cell>
                        );
                      })}

                      <Cell className={classes.tableCell}>
                        {isBool ? (
                          <div className={classes.alignCenter}>
                            <TrplCheckbox
                              label={restriction.title}
                              checked={trplValue === 'true'}
                              onChange={(e) => this.onTrplValueCheckboxChange(e, restriction.id)}
                            />

                            <Button
                              variant="contained"
                              size="small"
                              color="primary"
                              onClick={() => this.onTrplValueSaveClick()}
                              className={classes.saveBtn}
                            >
                              Save
                            </Button>
                          </div>
                        ) : (
                          <div className={classes.alignCenter}>
                            <TrplTextfield
                              label="Value"
                              type={isNumber ? 'number' : 'text'}
                              className={textFieldClassName}
                              style={{
                                marginBottom: 0,
                                marginTop: 0,
                              }}
                              multiline={isTextarea}
                              rows={isTextarea ? '5' : '1'}
                              value={trplValue}
                              onChange={(e) => this.onTrplTextValueChange(e.target.value)}
                              margin="normal"
                            />

                            {isNeedPrice ? <span className={classes.currency}>{currency}</span> : null}

                            <Button
                              variant="contained"
                              size="small"
                              color="primary"
                              onClick={() => this.onTrplValueSaveClick()}
                              className={classes.saveBtn}
                            >
                              Save
                            </Button>
                          </div>
                        )}
                      </Cell>
                    </TableRow>
                  ) : null}
                </TableBody>
              </Table>
            ) : null}

            {tab === 'table' ? (
              <Fragment>
                <Table key="filter-value">
                  <TableBody>
                    <TableRow>
                      {renderParts && renderParts.length
                        ? renderParts.map((renderPart, renderPartIndex) => {
                            const restriction = trplData.restrictions[renderPart];

                            let restrictionTitle;
                            let restrictionValues;

                            if (!restriction) {
                              restrictionTitle = renderPart;
                              restrictionValues = trplData.structure_vars[renderPartIndex];
                            } else {
                              restrictionTitle = restriction.title;
                              restrictionValues = restriction.values;
                            }

                            const filterRestrictions = ['', ...restrictionValues];

                            return (
                              <Cell key={renderPartIndex}>
                                <TrplSelect
                                  title={restrictionTitle}
                                  value={trplTableFilterValues[renderPartIndex]}
                                  onChange={(e) => this.onTrplTableFilterChange(renderPartIndex, e)}
                                  values={filterRestrictions}
                                  itemStyles={{
                                    minHeight: '36px',
                                  }}
                                />
                              </Cell>
                            );
                          })
                        : null}

                      <Cell />
                    </TableRow>

                    {trplData.structure_matrix
                      ? Object.keys(trplData.structure_matrix).map((structureMatrixKey, structureMatrixKeyIndex) => {
                          if (structureMatrixKeyIndex > loadMoreCounter) return null;

                          let filterValue;
                          let isRowFiltered = false;

                          trplData.structure_matrix[structureMatrixKey].forEach((key, keyIndex) => {
                            filterValue = trplTableFilterValues[keyIndex];

                            if (filterValue !== '' && key !== filterValue) {
                              if (!isRowFiltered) isRowFiltered = true;
                            }
                          });

                          if (isRowFiltered) return null;

                          return (
                            <TableRow key={structureMatrixKeyIndex}>
                              {trplData.structure_matrix[structureMatrixKey].map((key, keyIndex) => {
                                if (keyIndex === trplData.structure_matrix[structureMatrixKey].length - 1) {
                                  return [
                                    <Cell key={`key-${keyIndex}`} className={classes.tableCellValue}>
                                      {key}
                                    </Cell>,

                                    <Cell key={`value-${keyIndex}`}>
                                      <div className={classes.alignCenter}>
                                        {isBool ? (
                                          <TrplCheckbox
                                            checked={
                                              trplTableInputValues[
                                                trplData.structure_matrix[structureMatrixKey].toString()
                                              ] === 'true'
                                            }
                                            onChange={(e) => {
                                              this.onTrplTableValueChange(
                                                trplData.structure_matrix[structureMatrixKey].toString(),
                                                e
                                              );
                                            }}
                                            label={restriction.title}
                                          />
                                        ) : (
                                          <div
                                            style={{
                                              width: `${isTextarea ? '100%' : 'auto'}`,
                                            }}
                                            className={classes.alignCenter}
                                          >
                                            <TrplTextfield
                                              label="Value"
                                              type={isNumber ? 'number' : 'text'}
                                              className={textFieldClassName}
                                              multiline={isTextarea}
                                              rows={isTextarea ? '5' : '1'}
                                              onChange={(e) =>
                                                this.onTrplTableValueChange(
                                                  trplData.structure_matrix[structureMatrixKey].toString(),
                                                  e
                                                )
                                              }
                                              value={
                                                trplTableInputValues[
                                                  trplData.structure_matrix[structureMatrixKey].toString()
                                                ]
                                              }
                                            />

                                            {isPrice && keyIndex === locationIndex ? (
                                              <span className={classes.currency}>{locations[key].currency}</span>
                                            ) : (
                                              ''
                                            )}
                                          </div>
                                        )}

                                        <Button
                                          variant="contained"
                                          size="small"
                                          color="primary"
                                          onClick={() =>
                                            this.saveValueFromTrplTable(trplData.structure_matrix[structureMatrixKey])
                                          }
                                          className={classes.saveBtn}
                                        >
                                          Save
                                        </Button>
                                      </div>
                                    </Cell>,
                                  ];
                                }

                                return (
                                  <Cell key={keyIndex} className={classes.tableCellValue}>
                                    {key}
                                  </Cell>
                                );
                              })}
                            </TableRow>
                          );
                        })
                      : null}
                  </TableBody>
                </Table>

                {loadMoreCounter < Object.keys(trplData.structure_matrix).length ? (
                  <div className={classes.loadMoreFiltersContainer}>
                    <Button variant="contained" onClick={this.onLoadMoreFiltersClick} className={`${classes.mr10} ${classes.nowrap}`}>
                      Load more
                    </Button>

                    <Button color="primary" variant="contained" onClick={this.onLoadAllFiltersClick}>
                      Load all
                    </Button>
                  </div>
                ) : null}
              </Fragment>
            ) : null}

            {tab === 'advanced' ? (
              <CreateVirtualTrpl
                mode="edit"
                trplData={trplData}
                restriction={restriction}
                onCreateVirtualTrplBtn={this.onCreateVirtualTrplBtn}
                onVirtualRestrictionTextChange={this.onVirtualRestrictionTextChange}
              />
            ) : null}
          </div>
        )}
      </FullScreenDialog>
    );
  }
}

export default withStyles(styles)(TrplRenderPartsModal);
